import type { SafetyElementsProps } from "./Index.tsx";
import { useSafetyElements } from "./useSafetyElements.tsx";

const SafetyElementsMobile = ({ safetyElements, memberAssociations }: SafetyElementsProps) => {
  const elements = useSafetyElements({ safetyElements, memberAssociations });
  if (elements.length === 0) return null;
  return (
    <div className="mt-40 pt-40 border-t">
      <section className="space-y-40">
        {elements.map((element) => (
          <div key={element.id}>
            <span className="flex">
              {element.icon}
              <span className="font-bold flex items-center ml-4">{element.label}</span>
            </span>
            <div className="mt-16">{element.content}</div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default SafetyElementsMobile;
